import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { noop } from 'ui-components/default-props/noop';

const HelpMenuSectionItem = ({ url, target = '', onClick = noop, description, testId }) => {
  if (!url) {
    return (
      <DropdownMenuItem key={testId} onClick={onClick} testId={testId}>
        {description}
      </DropdownMenuItem>
    );
  }
  if (typeof url === 'string') {
    return (
      <DropdownMenuItem key={testId} href={url} onClick={onClick} target={target} testId={testId}>
        {description}
      </DropdownMenuItem>
    );
  }

  const UrlBySellerHomeCountry = url;

  return (
    <UrlBySellerHomeCountry key={testId}>
      {(sellerHomeCountryUrl) => (
        <DropdownMenuItem key={sellerHomeCountryUrl} href={sellerHomeCountryUrl} onClick={onClick} target={target} testId={testId}>
          {description}
        </DropdownMenuItem>
      )}
    </UrlBySellerHomeCountry>
  );
};

export const HelpMenuSectionItemPropTypes = {
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  target: PropTypes.string,
  onClick: PropTypes.func,
  description: PropTypes.node.isRequired,
  testId: PropTypes.string,
};

HelpMenuSectionItem.propTypes = HelpMenuSectionItemPropTypes;

export default HelpMenuSectionItem;
